import { InsertDriveFileOutlined } from '@mui/icons-material';
import {
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import DebouncedSearchInput from '../../components/DebouncedSearchInput';
import { useFileFolderSelection } from '../../components/Providers/FileFolderSelectionProvider';
import { CustomFile } from '../../Types/file';
import { formatDate } from '../../util/dateUtils';

interface FileListProps {
  files: CustomFile[];
  onSearch: (query: string) => void;
  searchQuery: string;
}

const ROW_HEIGHT = 56;

const FileList: React.FC<FileListProps> = ({ files, onSearch, searchQuery }) => {
  const { selectedFiles, handleFileSelect } = useFileFolderSelection();
  const isSelected = (file: CustomFile) => selectedFiles.some((f) => f.id === file.id);

  return (
    <>
      <Box sx={{ py: 1 }}>
        <DebouncedSearchInput labelText="Search" value={searchQuery} valueUpdated={onSearch} />
      </Box>
      <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
        <Table size="small" sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow sx={{ height: ROW_HEIGHT }}>
              {['File Name', 'Last Updated', 'Modified By'].map((title) => (
                <TableCell key={title}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {title}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {files.map((file) => (
              <TableRow
                key={file.id}
                hover
                selected={isSelected(file)}
                onClick={() => handleFileSelect(file)}
                sx={{
                  cursor: 'pointer',
                  height: ROW_HEIGHT,
                }}
              >
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Checkbox
                      checked={isSelected(file)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => handleFileSelect(file)}
                      sx={{ padding: 0, marginRight: 1 }}
                    />
                    <InsertDriveFileOutlined sx={{ marginRight: 1 }} />
                    <Typography>{file.fileName}</Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography fontWeight="bold">
                    {file.lastModified ? formatDate(file.lastModified) : '—'}
                  </Typography>
                </TableCell>
                <TableCell>{file.userId ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};

export default FileList;
